import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Button, ButtonToolbar} from 'reactstrap';

// Components
import NewPromptChildComponent from './NewPromptChildComponent'

export default class ModalComponent extends PureComponent {
  static propTypes = {
    cancel: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    colored: PropTypes.bool,
    message: PropTypes.string,
    modal: PropTypes.object,
    ok: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    newPrompt: PropTypes.any,
    icon: PropTypes.any,
    iconColor: PropTypes.any,
    buttonColor: PropTypes.any,
    link: PropTypes.any,
  } // END propTypes

  promptResult = confirmation => {
    const { modal } = this.props;
    if (modal) modal.toggle(confirmation);

  } // END promptResult

  render() {
    const { title, message, cancel, colored, color, ok, newPrompt, icon, iconColor,  buttonColor, modal, link } = this.props;

    if (newPrompt) {
      return (
        <NewPromptChildComponent
          title={ title }
          message={ message }
          cancel={ cancel }
          color={ color }
          icon={ icon }
          iconColor={ iconColor }
          buttonColor={ buttonColor }
          ok={ ok }
          modal={ modal }
          link={ link }
        />
      )
    }

    let Icon;
    switch (color) {
      case 'success':
          Icon = <span className='lnr lnr-thumbs-up modal__title-icon'/>;
          break;

        case 'warning':
          Icon = <span className='lnr lnr-flag modal__title-icon'/>;
          break;

        case 'danger':
          Icon = <span className='lnr lnr-cross-circle modal__title-icon'/>;
          break;

        case 'primary':
        default:
          Icon = <span className='lnr lnr-pushpin modal__title-icon'/>;
          break;

    } // END switch

    return (
       <React.Fragment>
          <div className='modal__header'>
            { Icon }
            <h4 className='bold-text  modal__title'>{ title }</h4>
          </div>
          <div className='modal__message'>
            { message }
          </div>
          <ButtonToolbar className='modal__footer'>
            <Button onClick={ () => this.promptResult('cancel') }>
              { cancel }
            </Button>
            {' '}
            <Button onClick={ () => this.promptResult('ok') } outline={ colored } color={ color }>
              { ok }
            </Button>
          </ButtonToolbar>
       </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modals/PromptChildComponent.js